module.exports = __webpack_public_path__ + "static/media/screen.73b299d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screen.svg
// module id = 896
// module chunks = 7